
import { useState } from 'react';

const tours = [
  {
    id: 1,
    title: 'Rota das Levadas do Caniçal',
    duration: '4h',
    difficulty: 'Moderado',
    price: '€65/pessoa',
    description: 'Explore as icónicas levadas de Machico ao Caniçal com guia especializado. Vista mar deslumbrante e natureza exuberante ao longo de todo o percurso.',
    highlights: ['Vista 360° sobre o oceano', 'Passagem por túneis históricos', 'Flora endémica da Madeira', 'Guia local experiente'],
    image: 'https://public.readdy.ai/ai/img_res/5b145f4075d558778b987372e5a354a8.jpg',
    tag: 'Mais Popular',
    tagColor: 'bg-nature-green',
  },
  {
    id: 2,
    title: 'Circuito Norte da Ilha',
    duration: '6h',
    difficulty: 'Avançado',
    price: '€95/pessoa',
    description: 'Percorra a costa norte selvagem da Madeira, com paragens em Santana, São Vicente e as famosas grutas vulcânicas. Uma aventura épica de mota 4.',
    highlights: ['Casas típicas de Santana', 'Grutas de São Vicente', 'Falésia do Cabo Girão', 'Almoço incluído'],
    image: 'https://readdy.ai/api/search-image?query=Quad%20bike%20adventure%20tour%20on%20rugged%20mountain%20terrain%20in%20Madeira%20island%2C%20volcanic%20landscape%2C%20dramatic%20cliffs%2C%20off-road%20adventure%2C%20group%20of%20riders%2C%20misty%20mountains%2C%20exciting%20outdoor%20activity%2C%20action%20photography&width=800&height=500&seq=mota2&orientation=landscape',
    tag: 'Aventura Total',
    tagColor: 'bg-amber-500',
  },
  {
    id: 3,
    title: 'Pôr do Sol no Cabo Girão',
    duration: '3h',
    difficulty: 'Fácil',
    price: '€45/pessoa',
    description: 'Um passeio ao entardecer até ao segundo maior cabo do mundo. Vistas espetaculares sobre o oceano Atlântico com o sol a mergulhar no horizonte.',
    highlights: ['Cabo Girão ao pôr do sol', 'Skywalk de vidro', 'Vinhas suspensas', 'Degustação de poncha'],
    image: 'https://readdy.ai/api/search-image?query=Sunset%20motorcycle%20ride%20along%20Madeira%20coastal%20road%2C%20golden%20hour%20light%2C%20dramatic%20ocean%20cliffs%2C%20silhouette%20of%20riders%2C%20warm%20orange%20sky%2C%20romantic%20adventure%20travel%2C%20scenic%20coastal%20highway%2C%20beautiful%20evening%20light&width=800&height=500&seq=mota3&orientation=landscape',
    tag: 'Romântico',
    tagColor: 'bg-rose-500',
  },
];

const PasseiosMota = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="passeios-mota" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-nature-green text-xs font-semibold uppercase tracking-widest mb-3">Adrenalina & Liberdade</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
            Passeios de <span className="font-serif italic text-sea-blue">Mota 4</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            Explore a Madeira de uma forma única — com o vento no rosto e as melhores vistas da ilha ao seu alcance.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar */}
          <div className="lg:w-1/3 flex flex-col gap-4">
            {tours.map((tour, idx) => (
              <button
                key={tour.id}
                onClick={() => setActive(idx)}
                className={`text-left p-5 rounded-2xl border-2 transition-all cursor-pointer ${
                  active === idx
                    ? 'border-sea-blue bg-sea-blue/5 shadow-md'
                    : 'border-gray-100 bg-white hover:border-sea-blue/30'
                }`}
              >
                <div className="flex items-start justify-between mb-2">
                  <h3 className={`font-semibold text-base ${active === idx ? 'text-sea-blue' : 'text-gray-800'}`}>
                    {tour.title}
                  </h3>
                  <span className={`${tour.tagColor} text-white text-xs px-2 py-0.5 rounded-full whitespace-nowrap ml-2`}>
                    {tour.tag}
                  </span>
                </div>
                <div className="flex items-center gap-4 text-sm text-gray-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {tour.duration}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-bar-chart-line"></i> {tour.difficulty}
                  </span>
                  <span className="font-semibold text-gray-700">{tour.price}</span>
                </div>
              </button>
            ))}
          </div>

          {/* Detail */}
          <div className="lg:w-2/3">
            <div className="rounded-3xl overflow-hidden shadow-xl bg-white border border-gray-100">
              <div className="relative w-full h-72">
                <img
                  src={tours[active].image}
                  alt={tours[active].title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-6 flex gap-3">
                  <span className="bg-white/20 backdrop-blur-sm text-white text-sm px-3 py-1 rounded-full flex items-center gap-1">
                    <i className="ri-time-line"></i> {tours[active].duration}
                  </span>
                  <span className="bg-white/20 backdrop-blur-sm text-white text-sm px-3 py-1 rounded-full flex items-center gap-1">
                    <i className="ri-bar-chart-line"></i> {tours[active].difficulty}
                  </span>
                </div>
              </div>
              <div className="p-8">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-2xl font-semibold text-gray-900">{tours[active].title}</h3>
                  <span className="text-2xl font-bold text-sea-blue">{tours[active].price}</span>
                </div>
                <p className="text-gray-600 leading-relaxed mb-6">{tours[active].description}</p>
                <div className="grid grid-cols-2 gap-3 mb-8">
                  {tours[active].highlights.map((h, i) => (
                    <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-check-line text-nature-green font-bold"></i>
                      </div>
                      {h}
                    </div>
                  ))}
                </div>
                <a
                  href="https://wa.me/351912345678"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-sea-blue text-white rounded-full font-semibold text-sm hover:bg-sea-blue/90 hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  Reservar via WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PasseiosMota;
